"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnItUsd = exports.EnItEur = exports.ItItUsd = exports.ItItEur = void 0;
class ItItEur {
    constructor() {
        this.locale = "it-it";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C",
        };
    }
}
exports.ItItEur = ItItEur;
class ItItUsd {
    constructor() {
        this.locale = "it-it";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "USD",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n",
        };
    }
}
exports.ItItUsd = ItItUsd;
class EnItEur {
    constructor() {
        this.locale = "en-it";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n",
        };
    }
}
exports.EnItEur = EnItEur;
class EnItUsd {
    constructor() {
        this.locale = "en-it";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "USD",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n",
        };
    }
}
exports.EnItUsd = EnItUsd;
